<template src="./template.html" />

<script>
/* eslint-disable */
import { directive as onClickaway } from 'vue-clickaway';
import Btn from '@/components/elements/buttons';

export default {
  name: 'dropdown',
  directives: {
    onClickaway: onClickaway,
  },
  components: { Btn },
  props: {
    cssClass: {
      type: String,
      default: 'brand'
    },
    icon: {
      type: Object,
      default: () => { return {
        name: 'dropdownArrow',
        size: '24',
      }}
    },
    buttonText: {
      type: String,
      default: 'Enter Button Name',
    },
    dropdownOptions: {
      type: Array,
    }
  },
  data() {
    return{
      opened: false,
    };
  },
  methods: {
    emitClick(optNumber, optObject) {
      this.$emit('optionSelected', optNumber, optObject);
    },
  },
}
</script>
